<template>
  <expandable header="Supra Urgent Details">
    <b-row>
      <b-col cols="12" md="6">
        <select-field
          label="Supra Urgent Listing Type"
          :disabled="isDisabled"
          rules="required"
          v-model="form.master_alf_id"
          @input="onInput"
          :items="masterALF"
        ></select-field>
      </b-col>
      <!-- Phase 2 - Supra Urgent Organ Type -->
      <b-col cols="12" md="6">
        <select-field
          label="Organ Type"
          :disabled="isDisabled"
          rules="required"
          v-model="form.organ_type"
          @input="onInput"
          :items="organTypes"
        ></select-field>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" md="4" class="mb-2">
        <file-input-group
          :disabled="isDisabled"
          v-model="form.file_name"
          @input="onFileChange"
          accept=".jpg,capture=camera,.jpeg,.png,.pdf"
          rules="required|file-image-pdf|file-size"
          :label="evaluationSheetLabel"
        ></file-input-group>
      </b-col>
      <b-col cols="12" md="4" class="mb-2">
        <file-input-group
          v-model="form.additional_hepatology_notes"
          :disabled="isDisabled"
          @input="onFileChange"
          accept=".jpg,capture=camera,.jpeg,.png,.pdf"
          rules="required|file-image-pdf|file-size"
          :label="clinicalNotesLabel"
        ></file-input-group>
      </b-col>
      <b-col cols="12" md="4" class="mb-2">
        <file-input-group
          v-model="form.consultant_short_summary"
          :disabled="isDisabled"
          @input="onFileChange"
          accept=".jpg,capture=camera,.jpeg,.png,.pdf"
          rules="required|file-image-pdf|file-size"
          label="Consultant Short Summary"
        ></file-input-group>
      </b-col>
    </b-row>
  </expandable>
</template>

<script>
import { openFile } from "../../../assets/js/common";
import { SUPRA_URGENT_ORGAN_TYPES } from "../../../assets/constants/alf.constants";
import Expandable from "../../Expandable.vue";
import FileInputGroup from "../../form/FileInputGroup.vue";
import SelectField from "../../form/SelectField.vue";
export default {
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  components: { Expandable, SelectField, FileInputGroup },
  data() {
    return {
      form: {},
      organTypes: SUPRA_URGENT_ORGAN_TYPES,
    };
  },
  computed: {
    evaluationSheetLabel() {
      if (this.form.organ_type == "106") return "Cardiac Evaluation Sheet";
      if (this.form.organ_type == "107") return "Pulmonary Evaluation Sheet";
      return "Supra Urgent Evaluation Sheet";
    },
    clinicalNotesLabel() {
      if (this.form.organ_type == "106") return "Additional Cardiology Notes";
      if (this.form.organ_type == "107") return "Additional Pulmonology Notes";
      return "Additional Hepatology Notes";
    },
  },
  methods: {
    isFile(file) {
      return file == null || file instanceof File;
    },
    onInput() {
      this.$emit("input", this.form);
    },
    open(file) {
      openFile(file);
    },
    onFileChange() {
      this.$emit("input", this.form);
    },
  },
  mounted() {
    this.form = this.value;
  },
};
</script>
<style></style>
